import { Base, Component, Inject } from '@/vue-property-decorator'
import { SquareProps } from '../../components/basePropsConfig'
import style from './style.module.scss'
export type GameNameNormalCssVar = {
  /** 游戏名称字号 */
  ['--game-name-font-size']?: string
}
@Component<GameNameNormal>({
  name: 'GameNameNormal'
})
export default class GameNameNormal extends Base {
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<SquareProps>

  render() {
    const { inCardRenderCategory, gameName } = this.cardProps
    return (
      <div
        class={{
          ['game-name']: true,
          [style['game-name']]: true,
          [style[`type-${inCardRenderCategory}-default`]]: true
        }}
      >
        <div
          class={{
            ['game-name-inner']: true,
            [style['game-name-inner']]: true
          }}
        >
          {gameName}
        </div>
      </div>
    )
  }
}
